"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { RatingStats } from "@/entities/IProfile";
import UserPageRepRepsTableBody from "./UserPageRepRepsTableBody";
import UserPageRepRepsTableHeader from "./UserPageRepRepsTableHeader";
import { SortDirection } from "@/entities/ISort";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export enum RepsTableSort {
  REP = "REP",
  RATERS = "RATERS",
  MY_RATES = "MY_RATES",
}
const DEFAULT_INITIAL_COUNT = 10;
export default function UserPageRepRepsTable(t0) {
  const $ = _c(43);
  const {
    reps,
    profile,
    canEditRep,
    initialCount: t1
  } = t0;
  const initialCount = t1 === undefined ? DEFAULT_INITIAL_COUNT : t1;
  const [showAll, setShowAll] = useState(false);
  const [sortType, setSortType] = useState(RepsTableSort.REP);
  const [sortDirection, setSortDirection] = useState(SortDirection.DESC);
  let t2;
  if ($[0] !== sortType) {
    t2 = newSortType => {
      if (newSortType === sortType) {
        setSortDirection(_temp);
      } else {
        setSortType(newSortType);
        setSortDirection(SortDirection.DESC);
      }
    };
    $[0] = sortType;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onSortTypeClick = t2;
  const compareValuesForSort = _temp2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (items, sort, dir_0) => {
      switch (sort) {
        case RepsTableSort.REP:
          {
            return items.sort((a_2, d_2) => compareValuesForSort(a_2.rating, d_2.rating, dir_0));
          }
        case RepsTableSort.RATERS:
          {
            return items.sort((a_1, d_1) => compareValuesForSort(a_1.contributor_count, d_1.contributor_count, dir_0));
          }
        case RepsTableSort.MY_RATES:
          {
            return items.sort((a_0, d_0) => compareValuesForSort(a_0.rater_contribution, d_0.rater_contribution, dir_0, true));
          }
        default:
          {
            assertUnreachable(sort);
            return items;
          }
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const sortReps = t3;
  let t4;
  if ($[3] !== reps || $[4] !== sortDirection || $[5] !== sortType) {
    t4 = sortReps(reps, sortType, sortDirection);
    $[3] = reps;
    $[4] = sortDirection;
    $[5] = sortType;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const [sortedReps, setSortedReps] = useState(t4);
  let t5;
  let t6;
  if ($[7] !== reps || $[8] !== sortDirection || $[9] !== sortType) {
    t5 = () => {
      setSortedReps(sortReps(reps, sortType, sortDirection));
    };
    t6 = [reps, sortType, sortDirection];
    $[7] = reps;
    $[8] = sortDirection;
    $[9] = sortType;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[12] !== canEditRep || $[13] !== sortType) {
    t7 = () => {
      if (!canEditRep && sortType === RepsTableSort.MY_RATES) {
        setSortType(RepsTableSort.REP);
        setSortDirection(SortDirection.DESC);
      }
    };
    t8 = [canEditRep, sortType];
    $[12] = canEditRep;
    $[13] = sortType;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  useEffect(t7, t8);
  let t9;
  if ($[16] !== initialCount || $[17] !== showAll || $[18] !== sortedReps) {
    t9 = showAll ? sortedReps : sortedReps.slice(0, initialCount);
    $[16] = initialCount;
    $[17] = showAll;
    $[18] = sortedReps;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const displayedReps = t9;
  const hasMore = sortedReps.length > initialCount;
  let t10;
  if ($[20] !== reps) {
    t10 = Math.max(...reps.map(_temp3), 0);
    $[20] = reps;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const maxRep = t10;
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      borderSpacing: "0 0.25rem"
    };
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== canEditRep || $[24] !== onSortTypeClick || $[25] !== sortDirection || $[26] !== sortType) {
    t12 = <UserPageRepRepsTableHeader activeType={sortType} sortDirection={sortDirection} showMyRates={canEditRep} onSortTypeClick={onSortTypeClick} />;
    $[23] = canEditRep;
    $[24] = onSortTypeClick;
    $[25] = sortDirection;
    $[26] = sortType;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== canEditRep || $[29] !== displayedReps || $[30] !== maxRep || $[31] !== profile) {
    t13 = <UserPageRepRepsTableBody reps={displayedReps} profile={profile} canEditRep={canEditRep} maxRep={maxRep} />;
    $[28] = canEditRep;
    $[29] = displayedReps;
    $[30] = maxRep;
    $[31] = profile;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <div className="tw-overflow-x-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300"><table className="tw-min-w-full tw-border-separate" style={t11}>{t12}{t13}</table></div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== hasMore || $[37] !== showAll || $[38] !== sortedReps.length) {
    t15 = hasMore && <button type="button" onClick={() => setShowAll(_temp4)} className="tw-w-full tw-mt-2 tw-py-2.5 tw-text-xs tw-font-medium tw-text-iron-400 tw-bg-transparent tw-border tw-border-solid tw-border-white/[0.14] tw-rounded-lg tw-cursor-pointer tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-iron-200 desktop-hover:hover:tw-border-white/[0.2]">{showAll ? "Show less" : `See all ${sortedReps.length}`}</button>;
    $[36] = hasMore;
    $[37] = showAll;
    $[38] = sortedReps.length;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t14 || $[41] !== t15) {
    t16 = <div className="tw-flow-root">{t14}{t15}</div>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
}
function _temp4(prev_0) {
  return !prev_0;
}
function _temp3(r) {
  return Math.abs(r.rating);
}
function _temp2(a, d, dir, t0) {
  const zeroAtEnd = t0 === undefined ? false : t0;
  if (!zeroAtEnd) {
    return dir === SortDirection.DESC ? d - a : a - d;
  }
  if (a === 0 && d === 0) {
    return 0;
  } else {
    if (a === 0) {
      return 1;
    } else {
      if (d === 0) {
        return -1;
      }
    }
  }
  return dir === SortDirection.DESC ? d - a : a - d;
}
function _temp(prev) {
  return prev === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
}